module.exports = __webpack_public_path__ + "img/im.21eb8c10.svg";